import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';

const state = () => ({
    data: [],
    loading: false,
    error: null,
    total: 0,
    userPermissions: [],
});

const actions = {
    async userPermissionReadAll({commit}) {

        try {
            const response = await DataService.get(`/user-permissions`);
            await commit('userPermissionReadAllSuccess', response.data.data.list);
            console.log('permissions for user', state.userPermissions);
        } catch (err) {
            await commit('userPermissionReadAllErr', err);
        }
    },
};

const getters = {
    hasPermission: (state) => (permission) => state.userPermissions.include(permission),
    getPermissions: (state) => state.userPermissions,
};

export default {
    state,
    actions,
    getters,
    mutations
}